import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { useBillingStore } from "@/stores/billing/billing-store";

export const GraduatePage: React.FC = () => {
  const createCheckoutSession = useBillingStore((state) => state.createCheckoutSession);
  const [isStarting, setIsStarting] = useState(false);

  const handleCheckout = async () => {
    setIsStarting(true);
    try {
      await createCheckoutSession("basic", "monthly", "graduation");
    } finally {
      setIsStarting(false);
    }
  };

  return (
    <main className="mx-auto max-w-2xl space-y-6 p-6">
      <div>
        <h1 className="text-2xl font-semibold">Graduate to Standalone</h1>
        <p className="text-sm text-muted-foreground">
          Upgrade to reactivate your personal workspace while keeping existing sponsorships.
        </p>
      </div>
      <Button onClick={() => void handleCheckout()} disabled={isStarting}>
        {isStarting ? "Starting..." : "Start Basic checkout"}
      </Button>
    </main>
  );
};
